export default __webpack_public_path__ + "940af94.png";